// extracted by mini-css-extract-plugin
export default {"page":"WX-z","cartModal":"XX-z","checkout":"YX-z","placeholder":"ZX-z","account":"_X-z"};